<template>
    <v-container>
        <v-layout>
            <v-flex xs12 sm10 offset-sm1 lg6 offset-lg3>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0" v-t="'title.new_account'"></h3>
                        </div>
                    </v-card-title>
                    <v-form ref="form" v-model="valid" v-if="!success" @submit.prevent="register">
                        <v-card-text class="text--primary">
                            <v-alert
                                class="mb-3"
                                :value="true"
                                type="error"
                                v-for="error in errors"
                                :key="error"
                                >{{ $t(`error.${error}`) }}</v-alert
                            >
                            <v-text-field
                                v-model="email"
                                :label="$t('label.email')"
                                required
                                type="email"
                                autocomplete="email"
                                :rules="[required, isEmail]"
                                filled
                            ></v-text-field>
                            <AddressForm v-model="address" />
                        </v-card-text>
                        <v-card-actions>
                            <router-link
                                :to="{ name: 'login' }"
                                color="primary"
                                v-t="'button.login'"
                            ></router-link>
                            <v-spacer></v-spacer>
                            <v-btn
                                type="submit"
                                color="primary"
                                v-t="'button.register'"
                                :disabled="loading"
                                :loading="loading"
                            ></v-btn>
                        </v-card-actions>
                    </v-form>

                    <v-card-text class="text--primary" v-else>
                        <p
                            class="title text-xs-center"
                            v-t="'message.account_waiting_for_validation'"
                        ></p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
import { mapGetters, mapActions } from "vuex"
import AddressForm from "@/components/AddressForm"
import isEmail from "validator/lib/isEmail"
export default {
    mixins: [loadingMixin],
    components: { AddressForm },
    data() {
        return {
            email: null,
            address: null,
            success: false,
            valid: false,
            errors: [],
        }
    },
    computed: {
        ...mapGetters({
            locale: "user/locale",
        }),
    },
    methods: {
        async register() {
            if (this.$refs.form.validate()) {
                this.loading = true
                this.errors = []
                try {
                    const {
                        data: { register },
                    } = await this.$apollo.mutate({
                        mutation: require("@/graphql/account/register.gql"),
                        variables: {
                            email: this.email,
                            locale: this.locale,
                            address: this.address,
                        },
                    })
                    if (!register.result) {
                        this.errors = [register.errors[0]]
                    } else {
                        this.success = true
                    }
                } catch (error) {
                    this.errors = [error.graphQLErrors.map((e) => e.message)[0]]
                }
                this.loading = false
            }
        },
        required(value) {
            return !!value || this.$t("error.required")
        },
        isEmail(value) {
            return (value && !!isEmail(value)) || this.$t("error.bad_format")
        },
    },
}
</script>
